module.exports = __webpack_public_path__ + "img/Patch23-4.d14dfacb.webp";